import asyncActionTypes from '../actions/types.js';

import HelperTraslatedCopy from '../../scripts/intl/helper-traslated-copy';
import storage from '../../scripts/utilities/storage-manager';

const initialState = {
  languageBundle: {},
  country: '',
  helperTraslatedCopy: null,
  loadingLanguageBundle: false,
  numEndpoints: 0,
  responseLanguageBundle: { translations: [] },
  errorLanguageBundle: false,
};

const languageBundle = (state = initialState, action) => {
  switch (action.type) {
    case asyncActionTypes.LANGUAGE_BUNDLE.START:
      return {
        ...state,
        loadingLanguageBundle: true,
        numEndpoints: action.payload.numEndpoints,
        errorLanguageBundle: false,
      };
    case asyncActionTypes.LANGUAGE_BUNDLE.SUCCESS:
      const isLoading = state.numEndpoints > action.payload.cont;
      const allLanguageBundle = [];
      const responseTranslations = action.payload.response && Array.isArray(action.payload.response.translations)
        ? action.payload.response.translations
        : [];
      const translations = {
        translations : state.responseLanguageBundle.translations.concat(responseTranslations),
      };
      // Es el ultimo endpoint de languageBundle
      if (!isLoading) {
        translations.translations.forEach((element) => {
          if (element && element.translation) {
            Object.assign(allLanguageBundle, { [element.translation.code] : element.translation.copy } );
          }
        });
        storage.set('mybLanguageBundleCMS', translations);
        storage.set('mybLanguage', action.payload.language);
      }
      return {
        ...state,
        languageBundle: !isLoading ? allLanguageBundle : {},
        helperTraslatedCopy: !isLoading ? new HelperTraslatedCopy(
          allLanguageBundle,
          action.payload.language,
          action.payload.storeFront,
          action.payload.country
        ) : null,
        country: action.payload.country,
        loadingLanguageBundle: isLoading,
        responseLanguageBundle: translations,
        errorLanguageBundle: false,
      };
    case asyncActionTypes.LANGUAGE_BUNDLE.FAIL:
      return {
        ...state,
        loadingLanguageBundle: false,
        errorLanguageBundle: true,
      };
    case asyncActionTypes.LANGUAGE_BUNDLE_CACHE.SUCCESS:
      const cacheLanguageBundle = [];
      const cacheTranslations = action.payload.cacheLanguageBundle && Array.isArray(action.payload.cacheLanguageBundle.translations)
        ? action.payload.cacheLanguageBundle.translations
        : [];
      cacheTranslations.forEach((element) => {
        if (element && element.translation) {
          Object.assign(cacheLanguageBundle, { [element.translation.code] : element.translation.copy } );
        }
      });
      return {
        ...state,
        languageBundle: cacheLanguageBundle,
        helperTraslatedCopy: new HelperTraslatedCopy(
          cacheLanguageBundle,
          action.payload.language,
          action.payload.storeFront,
          action.payload.country
        ),
        country: action.payload.country,
        loadingLanguageBundle: false,
        errorLanguageBundle: false,
      };
    default:
      return state;
  }
};

export default languageBundle;
